module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Filter-59485ff0f154378fb42c6786b377cc05.svg";